import { settingsService, SubscriptionConfig } from '@repo/ui/lib/api/services/settings.service';
import { useQuery } from '@tanstack/react-query';

export function usePublicSubscriptionConfig() {
  return useQuery<SubscriptionConfig, Error>({
    queryKey: ['subscription', 'public-config'],
    queryFn: () => settingsService.getPublicSubscriptionConfig(),
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
}


